import { render, staticRenderFns } from "./UpgradeWall.vue?vue&type=template&id=3ec34160"
import script from "./UpgradeWall.vue?vue&type=script&lang=js"
export * from "./UpgradeWall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports